import { Button, Flex, Grid, ScrollView } from "@aws-amplify/ui-react";
import { useContext } from "react";
import LocalizedStrings from "react-localization";
import CloseIcon from "@mui/icons-material/Close";
import { CCard, CCardBody, CCardFooter, CCardHeader } from "@coreui/react";
import toast from "react-hot-toast";

import { ScheduleContext } from "components/maintenanceSchedules/context/ScheduleContext";
import CompanyCard from "./CompanyCard";
import ServiceOrderCard from "./ServiceOrderCard";
import ExecutorCard from "../serviceOrders/ExecutorCard";
import GeneralDataCard from "./GeneralDataCard";
import ToolsCard from "./ToolsCard";
import SparesCard from "./SparesCard";

import "./style.css";
import RoutinesCard from "./RoutinesCard";

const ServiceOrderSelected = () => {
  const {
    selectedEvent,
    selectEvent,
    deleteEvent,
    updateEvent,
    selectUserExecutor,
  } = useContext(ScheduleContext);

  const onAddAuxExecutor = (id) => {
    if (
      selectedEvent.auxExecutors?.some((aux) => aux === id) ||
      selectedEvent.userExecutor === id
    ) {
      toast.error(strings.validations.existedExecutor);
      return;
    }
    updateEvent({
      id: selectedEvent.id,
      auxExecutors: [...(selectedEvent.auxExecutors ?? []), id],
    });
  };

  const onRemoveAuxExecutor = (id) => {
    updateEvent({
      id: selectedEvent.id,
      auxExecutors: selectedEvent.auxExecutors?.filter((aux) => aux !== id) ?? [],
    });
  };

  return !selectedEvent ? null : (
    <CCard
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <CCardHeader>
        <Flex justifyContent="space-between">
          <span className="fs-5 text-muted">{strings.title}</span>
          <CloseIcon
            style={{ cursor: "pointer" }}
            color="action"
            onClick={() => selectEvent(null)}
          />
        </Flex>
      </CCardHeader>
      <CCardBody style={{ maxHeight: "65vh" }}>
        <ScrollView style={{ height: "100%" }}>
          <Grid gap="10px" className="p-1">
            <ExecutorCard
              executorID={selectedEvent.userExecutor}
              selectUserExecutor={selectUserExecutor}
              hasAuxExecutors
              auxExecutors={selectedEvent.auxExecutors}
              onAddAuxExecutor={onAddAuxExecutor}
              onRemoveAuxExecutor={onRemoveAuxExecutor}
            />
            <CompanyCard companyID={selectedEvent.companyID} />
            <ServiceOrderCard
              serviceOrder={selectedEvent}
              equipmentID={selectedEvent.equipmentID}
            />
            <ToolsCard serviceOrder={selectedEvent} />
            <SparesCard serviceOrder={selectedEvent} />
            <RoutinesCard serviceOrder={selectedEvent} />
            <GeneralDataCard serviceOrder={selectedEvent} />
          </Grid>
        </ScrollView>
      </CCardBody>
      <CCardFooter>
        <Flex justifyContent="end">
          <Button
            variation="destructive"
            size="small"
            onClick={() => deleteEvent(selectedEvent.id)}
          >
            {strings.delete}
          </Button>
        </Flex>
      </CCardFooter>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Detalles de programación",
    delete: "Eliminar Programación",
    validations: {
      existedExecutor: "El ejecutor ya está registrado en la orden",
    },
  },
});

export default ServiceOrderSelected;
